import makeStyles from '@material-ui/core/styles/makeStyles'
import React from 'react'
import Typography from '@material-ui/core/Typography'

import { colors } from '../utils'

const useStyles = makeStyles(() => ({
  typo: {
    margin: '4px 0',
    color: colors.theme.palette.grey['600'],
    fontSize: '0.75rem',
  },
}))

export default ({ children, ...rest }) => (
  <Typography className={useStyles().typo} variant="body2" {...rest}>
    {children}
  </Typography>
)
